import { Textarea } from '@eigtech/ui/components/textarea'
import { FieldValues, useController } from 'react-hook-form'
import { WithFieldNameAndDefaultValueProps } from '../types/FieldProps'
import { BaseProps, FieldControl } from './FieldControl'

type Props<TFieldValues extends FieldValues = FieldValues> = {
  textareaProps?: React.ComponentProps<typeof Textarea>
} & BaseProps<TFieldValues> &
  Pick<React.ComponentProps<typeof Textarea>, 'rows'>

export type TextareaFieldProps<TFieldValues extends FieldValues = FieldValues> =
  WithFieldNameAndDefaultValueProps<Props<TFieldValues>, TFieldValues>

export function TextareaField<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  defaultValue,
  rows,
  textareaProps,
  ...props
}: TextareaFieldProps<TFieldValues>) {
  const {
    field,
    formState: { isSubmitting },
  } = useController({
    name,
    control,
    defaultValue,
  })

  return (
    <FieldControl control={control} disabled={isSubmitting} name={name} {...props}>
      <Textarea rows={rows} {...field} {...textareaProps} value={field.value ?? ''} />
    </FieldControl>
  )
}

export type TextareaFieldComponent<TFieldValues extends FieldValues = FieldValues> =
  typeof TextareaField<TFieldValues>
